import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, forwardRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { AIR_LANGUAGES, AirCalendar, AirLanguage, AirOptions, DatePickerModes } from './classes';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'air-datepicker',
  template: `
    <div class="date-control icon-calendar">
      <input type="text"
       value="{{airDate}}"
      (click)="openDatepicker()" (keydown)="disableKeys()" (keyup)="disableKeys()" (keypress)="disableKeys()"
      placeholder="YYYY-MM-DD" class="field date-field datepicker-here" [disabled]="viewMode" />
    </div>
    <div class="datepicker-inline" *ngIf="showDatepicker">
      <ng-container [ngSwitch]="mode">
        <div *ngSwitchCase="'datepicker'"
             datepicker
             [airDate]="_dateValue"
             [airOptions]="airOptions"
             [airCalendar]="airCalendar"
             [airLanguage]="airLanguage"
             (setDate)="setDate($event)"
             (setMonth)="airCalendar.setMonth($event); airMonthSelect.emit($event);"
             (monthSelection)="mode = 'monthpicker'"
             (close)="closeDatepicker($event)"
              class="datepicker"></div>

        <div *ngSwitchCase="'monthpicker'"
             monthpicker
             [airCalendar]="airCalendar"
             [airLanguage]="airLanguage"
             (setMonth)="airCalendar.setMonth($event); airMonthSelect.emit($event); mode = 'datepicker';"
             (setYear)="airCalendar.setYear($event); airYearSelect.emit($event);"
             (yearSelection)="mode = 'yearpicker'"
             class="datepicker"></div>

        <div *ngSwitchCase="'yearpicker'"
             yearpicker
             [airCalendar]="airCalendar"
             (setYear)="airCalendar.setYear($event); airYearSelect.emit($event); mode = 'monthpicker';"
             class="datepicker"></div>
      </ng-container>
    </div>
  `,
  //styleUrls: ['./angular2-air-datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Angular2AirDatepickerComponent),
    multi: true
  }]
})
export class Angular2AirDatepickerComponent implements OnInit, ControlValueAccessor {

  onModelChange: Function = () => { };
  onModelTouched: Function = () => { };

  @Input() airOptions: AirOptions;
  @Output() airOptionsChange = new EventEmitter<AirOptions>();
  //@Input() airDate: Date;
  @Input() airDate: string;
  @Input() viewMode: boolean = false;
  @Output() airDateChange = new EventEmitter<string>();
  @Output() airChange = new EventEmitter<Date>();
  @Output() airMonthSelect = new EventEmitter<number>();
  @Output() airYearSelect = new EventEmitter<number>();
  @Input() isRequired: boolean = false;
  @Output() isRequiredChange = new EventEmitter<boolean>();



  airLanguage: AirLanguage;
  airCalendar: AirCalendar;
  mode = 'datepicker';


  showDatepicker: boolean = false;

  _dateValue: Date;

  ngOnInit() {
    // debugger;
    try {
      this.mode = (this.airOptions.DateTimePicker_Mode == undefined || this.airOptions.DateTimePicker_Mode == null) ? this.mode : this.airOptions.DateTimePicker_Mode;//added on 20241009 to control the Datepicker
    } catch (e) {

    }

    this.initializeDatePicker(this.airDate);
    //console.log("ngOnInit");
    //this._dateValue = new Date();
    //if (this.airDate) {
    //  this._dateValue = new Date(this.airDate);
    //  this.airDate = this.airDate.split("T")[0];
    //};
    //this.airOptions = new AirOptions(this.airOptions || {} as AirOptions);
    //this.airOptions.language = "ar";
    //this.airLanguage = AIR_LANGUAGES.get(this.airOptions.language);
    ////this.airLanguage = AIR_LANGUAGES.get("ar");
    //this.airCalendar = new AirCalendar(this._dateValue, this.airOptions);
    //this.airCalendar = new AirCalendar(this.airOptions);
  }

  setDate(index?: number) {
    if (this.airCalendar.airDays[index]) {
      if (this.airCalendar.airDays[index].disabled) {
        return;
      }
      this.airCalendar.selectDate(index);
    }
    const time = new Date(this.airCalendar.year, this.airCalendar.month, this.airCalendar.date, this.airCalendar.hour, this.airCalendar.minute);
    if (!this.airOptions.isDisabled(new Date(time))) {
      this._dateValue.setTime(time.getTime());
      //this.airDate = this.initDate;
      if (this.airOptions.timepicker == true) {
        if (this.airOptions.DateTimePicker_ClickClose_Enabled) this.showDatepicker = false;//2024-02-13 
        this.airDate = this.formatDateTime(this._dateValue);
      }
      else {
        this.airDate = this.format(this._dateValue, "yyyy-MM-dd");
        this.showDatepicker = false;
      }
      if (this.onModelChange)
        this.onModelChange(this.airDate);
      this.airDateChange.emit(this.airDate);
      this.airChange.emit(this._dateValue);
    }


  }

  disableKeys(): boolean {
    return false;
  }

  format(x, y): string {
    var z = {
      M: x.getMonth() + 1,
      d: x.getDate(),
      h: x.getHours(),
      m: x.getMinutes(),
      s: x.getSeconds()
    };
    y = y.replace(/(M+|d+|h+|m+|s+)/g, function (v) {
      return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-2)
    });

    return y.replace(/(y+)/g, function (v) {
      return x.getFullYear().toString().slice(-v.length)
    });
  }

  formatDateTime(datetime): string {
    var hours = datetime.getHours();
    var minutes = datetime.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    let minutesStr = minutes < 10 ? `0${minutes}` : minutes;
    var strTime = hours + ':' + minutesStr + ' ' + ampm;
    return this.format(datetime, "yyyy-MM-dd") + " " + strTime;
  }

  openDatepicker(): void {
    if (!this.viewMode)
      this.showDatepicker = !this.showDatepicker;
    this.initializeDatePicker(this.airDate);
  }

  closeDatepicker(confirmed: boolean): void {
    if (confirmed) {
      if (this.airDate && this.isDateInsideDateRanges(new Date(this.airDate))) {
        this.showDatepicker = false;
      }
    }
    else {
      this.airDate = null;
      this.showDatepicker = false;
    }
  }

  initializeDatePicker(dateValue: any): void {
    this._dateValue = new Date();
    if (dateValue) {
      this._dateValue = new Date(dateValue);
      let minAllowedDate = new Date(1900, 0, 1, 0, 0, 0, 0);
      if (this._dateValue > minAllowedDate) {
        if (this.airOptions.timepicker)
          this.airDate = this.formatDateTime(new Date(dateValue));
        else
          this.airDate = dateValue.split("T")[0];
      }
      if (this.airOptions && this.airOptions.enabledDateRanges && this.airOptions.enabledDateRanges.length > 0) {
        if (!this.isDateInsideDateRanges(this._dateValue)) {
          this.airDate = null;
          this.airDateChange.emit(null);
        }
      }
    };
    this.airOptions = new AirOptions(this.airOptions || {} as AirOptions);
    //this.airOptions.language = "ar";
    if (!this.airOptions.language)
      this.airOptions.language = "en";

    this.airLanguage = AIR_LANGUAGES.get(this.airOptions.language);
    this.airCalendar = new AirCalendar(this._dateValue, this.airOptions);
    if (this.isRequired) {
      this.isRequiredChange.emit(this.isRequired);
    }
    else {
      this.isRequiredChange.emit(false);
    }

  }

  writeValue(value: any): void {
    this.initializeDatePicker(value);
    //this._dateValue = new Date();
    //if (value) {
    //  this._dateValue = new Date(value);
    //  this.airDate = value.split("T")[0];
    //};
    //this.airOptions = new AirOptions(this.airOptions || {} as AirOptions);
    //this.airLanguage = AIR_LANGUAGES.get(this.airOptions.language);
    //this.airCalendar = new AirCalendar(this._dateValue, this.airOptions);
  }

  registerOnChange(fn: any): void {

    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;

  }

  setDisabledState?(isDisabled: boolean): void {
    console.log(isDisabled);
  }

  isDateInsideDateRanges(date: Date) {
    var isValid = false;
    if (this.airOptions.enabledDateRanges.length > 0) {
      const dateRange = this.airOptions.enabledDateRanges[0]
      if (!this.airOptions.timepicker) {
        if (date.setHours(0, 0, 0, 0) > dateRange.start.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) < dateRange.end.setHours(23, 59, 59, 0)) {
          isValid = true;
        }
      }
      else {
        if (date > dateRange.start && date < dateRange.end) {
          isValid = true;
        }
      }
    }
    return isValid;
  }
}



